import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de6734b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flake-breadcrumb post-breadcrumb" }
const _hoisted_2 = { class: "clouds" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "d-flex flex-column align-items-center justify-content-around" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "post-breadcrumb-title" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "post-breadcrumb-title-text text-center" }, " What is LinkedIn Scraping? Challenges and 4 Use Cases ")
], -1))
const _hoisted_10 = {
  class: "post-breadcrumb-meta mt-4 d-flex align-items-baseline justify-content-between flex-wrap",
  style: {"width":"40%","z-index":"3"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "post-breadcrumb-meta-categ post-breadcrumb-meta-item align-items-baseline" }, " WHAT IS ", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_13 = { class: "post-breadcrumb-meta-date post-breadcrumb-meta-item d-flex justify-content-between" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("     MAY 28, 2022 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_16 = { class: "post-breadcrumb-meta-read post-breadcrumb-meta-item d-flex align-items-center justify-content-between" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("     5 MINS READ ")

import { reactive } from 'vue';
import { BIconCalendarEvent, BIconAlarm } from 'bootstrap-icons-vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const img = reactive({
  cloud1: require('@/blog/assets/img/cloud1.png'),
  cloud2: require('@/blog/assets/img/cloud2.png'),
  cloud3: require('@/blog/assets/img/cloud3.png'),
  cloud5: require('@/blog/assets/img/cloud5.png'),
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        width: "123",
        height: "63",
        src: _unref(img).cloud1,
        alt: "cloud",
        class: "cloud1 entered lazyloaded"
      }, null, 8, _hoisted_3),
      _createElementVNode("img", {
        width: "96",
        height: "56",
        src: _unref(img).cloud2,
        alt: "cloud",
        class: "cloud3 entered lazyloaded"
      }, null, 8, _hoisted_4),
      _createElementVNode("img", {
        width: "96",
        height: "56",
        src: _unref(img).cloud3,
        alt: "cloud",
        class: "cloud4 entered lazyloaded"
      }, null, 8, _hoisted_5),
      _createElementVNode("img", {
        width: "1920",
        height: "579",
        src: _unref(img).cloud5,
        alt: "cloud",
        class: "cloud6 entered lazyloaded"
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: "/blog/categories/what-is",
            class: "post-breadcrumb-meta-categ-container"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _hoisted_12,
          _createElementVNode("span", _hoisted_13, [
            _createVNode(_unref(BIconCalendarEvent), { class: "calender" }),
            _hoisted_14
          ]),
          _hoisted_15,
          _createElementVNode("span", _hoisted_16, [
            _createVNode(_unref(BIconAlarm)),
            _hoisted_17
          ])
        ])
      ])
    ])
  ]))
}
}

})